export const payment = {
  button: 'Запросить счет',
  company_name: 'Название компании',
  company_name_tooltip: 'Укажите название компании для которой будет выставлен счёт.',
  tooltip: 'Выберите валюту, в которой хотите получить счет.',
  tooltip_email: 'Выберите или введите адрес электронной почты на который будет отправлен счёт.',
  legal_entities: 'Этот способ оплаты доступен только для юридических лиц.',
  general: 'Основной',
  success:
    'Мы получили ваш запрос на создание счета. В ближайшее время с вами свяжется финансовый специалист.',
  asana_api_problems: 'Возникла ошибка. Повторите позже.',
  finance_email: 'Финансовый email',
  email_rates: 'Email для тарифов',
  email_optional: 'Дополнительный email',
  widget: {
    balance: {
      title: 'Баланс {value}',
      button: 'Пополнить баланс'
    },
    modal: {
      title: 'Пополнить баланс',
      no_methods: 'Нет доступных платежных методов',
      form: {
        field: {
          amount: 'Сумма'
        },
        submit: 'Оплатить',
        minimal_amount: 'Минимально ',
        alert_minimum: 'Указанная сумма меньше минимального значения.',
        method_message: {
          comepay: '',
          fondy: '',
          invoice_request: '',
          tinkoff: 'Будет удержана комиссия 2,25%',
          webmoney: 'При оплате через WebMoney будет удержана комиссия 3,5%',
          yoomoney: 'При оплате через ЮMoney будет удержана комиссия 5,5%',
          capitalist: '',
          paypal: 'При оплате через PayPal будет удержана комиссия'
        }
      }
    }
  },
  errors: {
    check_user_phone: 'По требованиям НСПК для платежей с банковских карт, необходимо указать ваш номер телефона в <a href=".">профиле</a>'
  }
};
